'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-undef: "off" */
/**
 * search pane(已废弃)
 */
define('searchPanel',['busEvent', 'jquery', 'util', 'searchSortApi'], function (busEvent, $, Util, searchSortApi) {
  return {
    template: '\n      <div class="in-search-container">\n        <transition name="fade">\n          <form class="in-search-panel" v-if="isPageShow" @submit.prevent="submit">\n            <div class="in-search-wrapper">\n              <div class="in-search-box">\n                <div class="in-ads-title" ref="adsTitle">\n                    <h2 v-text="i18n.find"></h2>\n                    <hr class="in-ads-hr" />\n                </div>\n                <div class="in-search-input">\n                  <i class="iconfont icon-search"></i>\n                  <input type="text" ref="searchInput" v-model.trim="keyWords" />\n                  <i class="iconfont icon-guanbi icon-close" @click="hideSearchPanel"></i>\n                  <div class="in-search-pre-wrapper">\n                    <ul>\n                      <li v-for="item in productList">\n                        <img :src="item.imgurl" :alt="item.name" />\n                        <a class="in-info" :href="item.product_url">\n                          <h6 v-text="item.name"></h6>\n                          <div class="in-ads-product-price">\n                            <span class="in-price-final" v-if="parseInt(item.max_price) > parseInt(item.final_price)" v-html="item.final_price_label"></span>\n                            <span class="in-price-max" :class="{final: parseInt(item.max_price) > parseInt(item.final_price)}" v-html="item.max_price_label"></span>\n                          </div>\n                        </a>\n                      </li>\n                    </ul>\n\n                    <div class="in-hot-keywords" v-if="hotKeyWords.length > 0">\n                      <label v-text="i18n.hotKeywords + \':\' "></label>\n                      <ul>\n                        <li v-for="keyWord in hotKeyWords">\n                          <a target="_blank" :href="\'/catalogsearch/result/?q=\' + keyWord" v-text="keyWord"></a>\n                        </li>\n                      </ul>\n                    </div>\n\n                  </div>\n                </div>\n              </div>\n              <div class="in-search-logo">\n                <a :href="logo.link">\n                  <img :src="logo.url" />\n                </a>\n              </div>\n            </div>\n          </form>\n        </transition>\n      </div>\n    ',
    data: function data() {
      return {
        isPageShow: false,
        logo: {},
        i18n: {
          find: 'Find your dream mobile now',
          hotKeywords: 'Hot Keywords'
        },
        keyWords: '',
        page: 1,
        pageSize: 4,
        productList: [],
        hotKeyWords: []
      };
    },
    mounted: function mounted() {

      // this.init()
      // this.onEnter()
    },

    watch: {
      keyWords: function keyWords(newKw, oldKw) {
        this.getKeyWords();
      }
    },
    methods: {
      init: function init() {
        this.onShowEvent();
        this.logo = window.commonDataJSON.logo;
        this.hotKeyWords = [].concat(_toConsumableArray(window.commonDataJSON.trending_search_kws));
      },
      onShowEvent: function onShowEvent() {
        var _this = this;

        busEvent.$on('showSearchEvent', function () {
          _this.isPageShow = true;
          document.body.className = 'in-overflow';
          _this.onFocusSearch();
          _this.onBlurSearch();
        });
      },
      hideSearchPanel: function hideSearchPanel() {
        this.isPageShow = false;
        document.body.className = '';
        this.unBlurSearch();
        this.unFocusSearch();
        this.productList = [];
        this.keyWords = '';
      },
      onBlurSearch: function onBlurSearch() {
        var _this2 = this;

        setTimeout(function () {
          $(_this2.$refs.searchInput).on('blur', _this2.blurSearchEvent);
        }, 20);
      },
      onFocusSearch: function onFocusSearch() {
        var _this3 = this;

        setTimeout(function () {
          $(_this3.$refs.searchInput).on('focus', _this3.focusSearchEvent);
        }, 20);
      },
      unBlurSearch: function unBlurSearch() {
        var _this4 = this;

        setTimeout(function () {
          $(_this4.$refs.searchInput).off('blur', _this4.blurSearchEvent);
        }, 20);
      },
      unFocusSearch: function unFocusSearch() {
        var _this5 = this;

        setTimeout(function () {
          $(_this5.$refs.searchInput).off('focus', _this5.focusSearchEvent);
        }, 20);
      },
      focusSearchEvent: function focusSearchEvent() {
        $(this.$refs.adsTitle).css({
          marginTop: 0,
          opacity: 0
        });
      },
      blurSearchEvent: function blurSearchEvent() {
        $(this.$refs.adsTitle).css({
          marginTop: '120px',
          opacity: 1
        });
      },
      onEnter: function onEnter() {
        var self = this;
        $(window).keydown(function (event) {
          switch (event.keyCode) {
            case 27:
              self.hideSearchPanel();
              break;
            default:
          }
        });
      },
      submit: function submit() {
        if (this.keyWords) {
          Util.redirect('/catalogsearch/result/?q=' + this.keyWords);
        }
      },

      /**
       * 获取预搜索列表
       */
      getKeyWords: Util.debounce(function () {
        var _this6 = this;

        searchSortApi({
          kws: this.keyWords,
          page: this.page,
          pageSize: this.pageSize
        }).then(function (resData) {
          if (resData.items.length > 0) {
            _this6.productList = resData.items;
          }
        });
      }, 500)
    }
  };
});
